import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageUploadTiles } from '../-components/PageUploadTiles'
import { useCoreUploadTiles } from '../-hooks/useCoreUploadTiles'
import { MATERIALS_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/materials/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('uploads')
  const tiles = useCoreUploadTiles(MATERIALS_UPLOAD_TYPES)

  return (
    <PageUploadTiles
      tiles={tiles}
      header={t('uploadData.materials.title')}
      description={t('uploadData.materials.description')}
    />
  )
}
